<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование новости" : "Добавление новости"'
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs12)
          s-publish-date-status(
            :errors='errors'
            :model='item'
          )
        v-flex(xs12)
          v-select(
              v-model='item.tags'
              label='Тэги для новости'
              multiple
              chips
              :items = 'tagsList'
              item-value='id'
              item-text='name'
              class='tag-input'
              retur-object
              type = 'array'
          )
        v-flex(xs12)
          s-sites-picker(
            v-model='sites'
            multiple
            chips
          )
        v-flex(xs12)
          v-text-field(
            :error='errors.has("name")'
            :error-messages='errors.first("name")'
            v-model='item.name'
            label='Название'
          )
        v-flex(xs12)
          s-slug-input(
            :model='item'
          )
        v-flex(xs12)
          v-text-field(
            v-model='item.source_link'
            :error='errors.has("source_link")'
            :error-messages='errors.first("source_link")'
            label='Ссылка на источник в СМИ'
          )                    
        v-flex(xs12)
          v-textarea(
            :error='errors.has("annotation")'
            :error-messages='errors.first("annotation")'
            v-model='item.annotation'
            label='Краткий текст'
            counter
          )
        v-flex(v-if="editor" xs12)
          div(class='subheading font-weight-medium mb-3') Полный текст
          ckeditor(v-model='item.body')
        v-flex(v-else xs12)
          v-textarea(
            v-model='item.body'
            :rows=15
            label='Исходный код новости'
          )
        v-flex(xs12 small)
          v-textarea(
            :error='errors.has("law_text")'
            :error-messages='errors.first("law_text")'
            v-model='item.law_text'
            :rows=15
            label='Юридическая информация'
            counter
          )
        v-flex(xs12 sm4)
          s-image-upload(
            :src='item.picture_url'
            v-model='item.picture'
            ratio='auto'
            label='Картинка квадрат (МП, промосайты)'
          )  
        v-flex(xs12 sm4)
          s-image-upload(
            :src='item.picture_wide_url'
            v-model='item.picture_wide'
            ratio='auto'
            label='Картинка 16:9 (корп сайт)'
          ) 
        v-flex(xs12)
          s-sortable(
            @change='onFilesSort'
            @remove='onFileRemove'
            :sortable='item.files'
            :openable='true'
            :deletable='true'
          )
        v-flex(xs12)
          dropzone(
            v-model='files'
            @error='$root.showSnack("Ошибка загрузки файла")'
          )
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        @click='onSave'
        :loading='isLoading'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import { createFormData } from '@/utils'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id'],

  components: {
    Ckeditor: () => import('@/components/async/Ckeditor'),
    Dropzone: () => import('@/components/async/Dropzone')
  },

  data: () => ({
    item: {},
    files: {},
    editor: true,
    tagsList: [
        {
          id: 'news',
          name: 'Новости'
        },
        {
          id: 'smi',
          name: 'СМИ о нас'
        },
        {
          id: 'press',
          name: 'Пресс-релизы'
        },
        {
          id: 'company',
          name: 'О компании'
        }
      ]
  }),

  async created() {
    if (!this.id) return
    this.updateItem()
  },

  methods: {
    async updateItem() {
      this.item = (await this.fetchSingle({ id: this.id })).data
    },

    async onSave() {
      this.item.tags = this.item.tags.join(',')
      let data = createFormData(this.item)
      data.append('attachFiles', Object.keys(this.files))
      data.append('picture', this.item.picture)
      data.append('site_ids', this.sites.join(','))


      try {
        if (this.id) {
          await this.update({ id: this.id, data })
        } else {
          await this.create({ data })
        }
        this.$root.showSnack('Новость сохранена')
        this.$router.push({ name: 'Content.News.List' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    async onFilesSort(files) {
      if (!this.isLoading) {
        try {
          await this.sortFiles(files.map(x => x.hash))
        } catch (e) {
          this.$root.showSnack('Ошибка сортировки файлов')
        }
      }
    },

    async onFileRemove({ hash }) {
      if (!this.isLoading && (await this.$confirm('Вы уверены?'))) {
        try {
          await this.removeFile(hash)
          this.updateItem()
        } catch (e) {
          this.$root.showSnack('Ошибка удаления файла')
        }
      }
    },

    ...mapActions('content/news', [
      'fetchSingle',
      'update',
      'create',
      'removeFile',
      'sortFiles'
    ])
  },

  computed: {
    sites: {
      get() {
        let { site_ids } = this.item

        if (!site_ids) {
          return []
        }
        var res = site_ids.split(/,/).map(x => +x)
        return res
      },

      set(val) {
        this.item.site_ids = val.join(',')
      }
    },
    ...mapGetters('content/news', ['isLoading'])
  }
}
</script>

<style>
.small textarea {
  font-size: 12px;
}
</style>
